import { createSlice } from "@reduxjs/toolkit";

import { ExecutorRate } from "../../../../../services";
import { ReduxReducer } from "../../../../interface";
import { GlobalState } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	subscription: {
		basic: [],
	},
};

const setSubscriptionBasicData: ReduxReducer<State, ExecutorRate.Model[]> = (
	state,
	action,
) => {
	state.subscription.basic = action.payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const globalStateExecutorRateData = createSlice({
	name: GlobalState.ConstantGlobalStateSlice.EXECUTOR_RATE_DATA,
	initialState,
	reducers: {
		reset,
		setSubscriptionBasicData,
	},
});

export const globalStateExecutorRateDataAction =
	globalStateExecutorRateData.actions;
export const globalStateExecutorRateDataReducer =
	globalStateExecutorRateData.reducer;
export type globalStateExecutorRateDataState = State;

export default globalStateExecutorRateData;
